import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoRadAdmDadosFaturamentoUnidata({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'radadmdadosfaturamentounidata', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoRadAdmDadosFaturamentoUnidata({ payload }) {
  try {
    const { fatu_codigo, params } = payload;

    yield call(api.delete, `radadmdadosfaturamentounidata/${fatu_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoradadmdadosfaturamentounidata, params } = payload;

    yield call(
      api.post,
      'radadmdadosfaturamentounidata',
      operacaoradadmdadosfaturamentounidata
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/radadmdadosfaturamentounidata');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { fatu_codigo } = payload;

    const { data } = yield call(
      api.get,
      `radadmdadosfaturamentounidata/${fatu_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoradadmdadosfaturamentounidata, params } = payload;

    yield call(
      api.put,
      'radadmdadosfaturamentounidata',
      operacaoradadmdadosfaturamentounidata
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/radadmdadosfaturamentounidata');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'radadmdadosfaturamentounidata', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoradadmdadosfaturamentounidata/OPERACAORADADMDADOSFATURAMENTOUNIDATA_IN_REQUEST',
    requestOperacaoRadAdmDadosFaturamentoUnidata
  ),
  takeLatest(
    '@operacaoradadmdadosfaturamentounidata/DELETE_OPERACAORADADMDADOSFATURAMENTOUNIDATA',
    deleteOperacaoRadAdmDadosFaturamentoUnidata
  ),
  takeLatest(
    '@operacaoradadmdadosfaturamentounidata/SUCCESS_REMOVE',
    requestOperacaoRadAdmDadosFaturamentoUnidata
  ),
  takeLatest(
    '@operacaoradadmdadosfaturamentounidata/STORE_OPERACAORADADMDADOSFATURAMENTOUNIDATA',
    store
  ),
  takeLatest(
    '@operacaoradadmdadosfaturamentounidata/FIND_OPERACAORADADMDADOSFATURAMENTOUNIDATA',
    find
  ),
  takeLatest(
    '@operacaoradadmdadosfaturamentounidata/UPDATE_OPERACAORADADMDADOSFATURAMENTOUNIDATA',
    update
  ),
  takeLatest(
    '@operacaoradadmdadosfaturamentounidata/RECORD_FILTERING',
    applyedFilters
  ),
]);
